(() => {
  const formatMoney = (cents, currency) => new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);

  document.querySelectorAll('[data-ky-pdp]').forEach((root) => {
    const placeholderStoneCopy = new Set([
      'pierre naturelle',
      'bijou quotidien',
      'association facile',
      'met en valeur les nuances naturelles de la pierre.',
      'se porte facilement au quotidien.',
      "s'associe avec d'autres pierres selon vos goûts.",
      'chaque perle peut présenter de légères variations.',
      'une pierre naturelle facile à porter',
    ]);
    const cleanStoneText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    root.querySelectorAll('#intents .chip').forEach((chip) => {
      if (placeholderStoneCopy.has(cleanStoneText(chip.textContent.replace('✦', '')))) chip.remove();
    });
    const intents = root.querySelector('#intents');
    if (intents && !intents.querySelector('.chip')) intents.style.display = 'none';
    root.querySelectorAll('.hero-stone ul').forEach((list) => {
      const items = [...list.querySelectorAll('li')];
      const hasOnlyPlaceholders = items.length > 0 && items.every((item) => placeholderStoneCopy.has(cleanStoneText(item.textContent)));
      if (hasOnlyPlaceholders) list.remove();
    });

    const thumbs = [...root.querySelectorAll('[data-ky-gallery-thumb]')];
    const dots = [...root.querySelectorAll('[data-ky-gallery-dot]')];
    const stage = root.querySelector('[data-ky-gallery-stage]');
    const mediaItems = [...root.querySelectorAll('[data-ky-gallery-media]')];
    const stageImg = root.querySelector('[data-ky-gallery-image]');
    const stagePh = root.querySelector('[data-ky-gallery-placeholder]');
    const currency = root.dataset.currency || 'EUR';
    let currentImage = 0;
    let swipeStart = null;

    const selectImage = (index) => {
      if (!thumbs.length) return;
      currentImage = (index + thumbs.length) % thumbs.length;
      thumbs.forEach((thumb, i) => thumb.classList.toggle('on', i === currentImage));
      dots.forEach((dot, i) => dot.classList.toggle('on', i === currentImage));

      if (mediaItems.length) {
        mediaItems.forEach((item, i) => {
          const selected = i === currentImage;
          item.classList.toggle('on', selected);
          item.querySelectorAll('video').forEach((video) => {
            if (!selected) video.pause();
          });
        });
        if (stagePh) stagePh.style.display = 'none';
        return;
      }

      const image = thumbs[currentImage].querySelector('img');
      if (image) {
        const fullSrc = image.dataset.fullSrc || image.currentSrc || image.src;
        if (!stageImg) return;
        stageImg.removeAttribute('srcset');
        stageImg.src = fullSrc;
        stageImg.alt = image.alt || '';
        if (image.getAttribute('width')) stageImg.setAttribute('width', image.getAttribute('width'));
        if (image.getAttribute('height')) stageImg.setAttribute('height', image.getAttribute('height'));
        stageImg.style.display = '';
        if (stagePh) stagePh.style.display = 'none';
      } else {
        stageImg?.removeAttribute('src');
        if (stageImg) stageImg.style.display = 'none';
        if (stagePh) stagePh.style.display = 'flex';
      }
    };

    root.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-ky-gallery-thumb]');
      if (thumb) {
        event.preventDefault();
        selectImage(thumbs.indexOf(thumb));
        return;
      }
      const dot = event.target.closest('[data-ky-gallery-dot]');
      if (dot) {
        event.preventDefault();
        selectImage(dots.indexOf(dot));
        return;
      }
      if (event.target.closest('[data-ky-gallery-prev]')) {
        event.preventDefault();
        selectImage(currentImage - 1);
        return;
      }
      if (event.target.closest('[data-ky-gallery-next]')) {
        event.preventDefault();
        selectImage(currentImage + 1);
        return;
      }
      const mediaTrigger = event.target.closest('[data-ky-load-media]');
      if (mediaTrigger) {
        event.preventDefault();
        const mediaShell = mediaTrigger.closest('[data-ky-gallery-media]');
        const template = mediaShell?.querySelector('[data-ky-media-template]');
        if (!template) return;
        const fragment = template.content.cloneNode(true);
        mediaTrigger.replaceWith(fragment);
        const video = mediaShell.querySelector('video');
        video?.play?.().catch(() => {});
      }
	    });

    stage?.addEventListener('touchstart', (event) => {
      swipeStart = event.touches[0].clientX;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      if (swipeStart === null || thumbs.length < 2) return;
      const delta = event.changedTouches[0].clientX - swipeStart;
      if (Math.abs(delta) > 40) selectImage(currentImage + (delta < 0 ? 1 : -1));
      swipeStart = null;
    }, { passive: true });

    const tiers = [...root.querySelectorAll('#tiers .tier')];
    const priceNow = root.querySelector('#priceNow');
    const priceWas = root.querySelector('#priceWas');
    const priceOff = root.querySelector('#priceOff');
    const atcPrice = root.querySelector('#atcPrice');
    const stickyPriceNow = root.querySelector('#stickyPriceNow');
    const stickyPriceWas = root.querySelector('#stickyPriceWas');
    const stickyFormat = root.querySelector('[data-ky-pdp-sticky-format]');
    const formatName = root.querySelector('#fmtName');
    const addButton = root.querySelector('[data-ky-pdp-atc]');
    const sticky = root.querySelector('[data-ky-pdp-sticky]');
    const stickyAddButton = root.querySelector('[data-ky-pdp-sticky-atc]');

    const selectTier = (tier) => {
      tiers.forEach((item) => {
        const selected = item === tier;
        item.classList.toggle('on', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      const cents = Number(tier.dataset.price || 0);
      const wasCents = Number(tier.dataset.was || 0);
      const discount = tier.dataset.off || '';
      const money = formatMoney(cents, currency);
      if (priceNow) priceNow.textContent = money;
      if (priceWas) {
        priceWas.textContent = wasCents ? formatMoney(wasCents, currency) : '';
        priceWas.style.display = wasCents ? '' : 'none';
      }
      if (priceOff) {
        priceOff.textContent = discount;
        priceOff.style.display = discount ? '' : 'none';
      }
      if (atcPrice) atcPrice.textContent = money;
      if (stickyPriceNow) stickyPriceNow.textContent = money;
      if (stickyPriceWas) {
        stickyPriceWas.textContent = wasCents ? formatMoney(wasCents, currency) : '';
        stickyPriceWas.hidden = !wasCents;
      }
      if (formatName) formatName.textContent = tier.dataset.format || '';
      if (stickyFormat) stickyFormat.textContent = tier.dataset.format || '';
    };

    tiers.forEach((tier) => {
      tier.addEventListener('click', () => selectTier(tier));
      tier.addEventListener('keydown', (event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          selectTier(tier);
        }
      });
    });

    const variantJson = root.querySelector('[data-ky-variants-json]');
    const optionButtons = [...root.querySelectorAll('[data-ky-option-value]')];
    let variants = [];
    try {
      variants = variantJson ? JSON.parse(variantJson.textContent || '[]') : [];
    } catch (_) {
      variants = [];
    }

    const normalizeVariantId = (id) => Number(String(id || '').split('/').pop());
    const getVariantOption = (variant, position) => {
      if (Array.isArray(variant.options)) return String(variant.options[position - 1] || '');
      const direct = variant[`option${position}`];
      if (direct != null) return String(direct);
      const selected = variant.selected_options || variant.selectedOptions || [];
      const match = selected[position - 1];
      return String(match?.value || '');
    };
    const isVariantAvailable = (variant) => variant && (
      variant.available === true ||
      variant.available_for_sale === true ||
      variant.availableForSale === true
    );
    const selectedOptions = () => {
      const values = {};
      optionButtons.forEach((button) => {
        if (button.classList.contains('on')) values[button.dataset.optionPosition] = button.dataset.optionValue || '';
      });
      return values;
    };
    const variantMatches = (variant, values) => Object.keys(values).every((position) => getVariantOption(variant, Number(position)) === values[position]);
    const findSelectedVariant = () => variants.find((variant) => variantMatches(variant, selectedOptions()));
    const roundSalePercent = (compare, price) => {
      if (!compare || compare <= price) return 0;
      let percent = Math.floor(((compare - price) * 100) / compare);
      const remainder = percent % 5;
      percent = remainder >= 3 ? percent + 5 - remainder : percent - remainder;
      return Math.max(0, percent);
    };
    const updateAvailability = () => {
      optionButtons.forEach((button) => {
        const trial = selectedOptions();
        trial[button.dataset.optionPosition] = button.dataset.optionValue || '';
        const canSelect = variants.some((variant) => variantMatches(variant, trial) && isVariantAvailable(variant));
        button.disabled = !canSelect;
        button.classList.toggle('oos', !canSelect);
      });
    };
    const updateTierPrices = (variant) => {
      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || variant.compareAtPrice || 0);
      const salePercent = roundSalePercent(compare, price);
      tiers.forEach((tier) => {
        const quantity = Math.max(1, Number(tier.dataset.tier || 1));
        const multiplier = Number(tier.dataset.multiplier || quantity * 100);
        const tierPrice = Math.round((price * multiplier) / 100);
        const tierWas = quantity > 1 ? price * quantity : compare;
        const tierUnitPercent = Math.floor(multiplier / quantity);
        const tierDiscount = Math.max(0, 100 - tierUnitPercent);
        const tierDiscountLabel = quantity > 1 && tierDiscount > 0 ? `−${tierDiscount}%` : (salePercent ? `−${salePercent}%` : '');
        tier.dataset.price = String(tierPrice);
        tier.dataset.was = tierWas > tierPrice ? String(tierWas) : '0';
        tier.dataset.off = tierDiscountLabel;
        const now = tier.querySelector('.pr .now');
        const was = tier.querySelector('.pr .was');
        const off = tier.querySelector('.pr .off');
        if (now) now.textContent = formatMoney(tierPrice, currency);
        if (was) was.textContent = tierWas > tierPrice ? formatMoney(tierWas, currency) : '';
        if (off) off.textContent = tierDiscountLabel;
      });
      const selectedTier = root.querySelector('#tiers .tier.on') || tiers[0];
      if (selectedTier) selectTier(selectedTier);
    };
    const updateVariantMedia = (variant) => {
      const mediaId = variant.featured_media?.id || variant.featured_media_id || variant.featured_image?.id;
      if (!mediaId) return;
      const mediaThumb = thumbs.find((thumb) => String(thumb.dataset.mediaId) === String(mediaId));
      if (mediaThumb) selectImage(thumbs.indexOf(mediaThumb));
    };
    const applyVariant = (variant, updateUrl = true) => {
      if (!variant) return;
      const variantId = normalizeVariantId(variant.id);
      const available = isVariantAvailable(variant);
      const price = Number(variant.price || 0);
      [addButton, stickyAddButton].forEach((button) => {
        if (!button) return;
        button.dataset.variantId = String(variantId);
        button.dataset.variantPrice = String(price);
        button.dataset.available = available ? 'true' : 'false';
        button.disabled = !available;
        button.classList.toggle('oos', !available);
      });
      root.setAttribute('data-stock', available ? 'in' : 'out');
      updateTierPrices(variant);
      updateVariantMedia(variant);
      if (updateUrl && variantId && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        window.history.replaceState({}, '', url.toString());
      }
    };

    if (variants.length && optionButtons.length) {
      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          const position = button.dataset.optionPosition;
          optionButtons
            .filter((item) => item.dataset.optionPosition === position)
            .forEach((item) => {
              const selected = item === button;
              item.classList.toggle('on', selected);
              item.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
          const group = button.closest('[data-ky-option-group]');
          const selectedLabel = group?.querySelector('[data-ky-option-selected]');
          if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue || '';
          updateAvailability();
          applyVariant(findSelectedVariant());
        });
      });
      updateAvailability();
      applyVariant(findSelectedVariant(), false);
    }

    const copy = root.querySelector('#offerCopy');
    const offer = root.querySelector('#offer');
    if (offer) offer.style.display = '';
    copy?.addEventListener('click', async () => {
      const code = root.querySelector('#offerCode')?.textContent.trim() || '';
      try {
        await navigator.clipboard.writeText(code);
      } catch (_) {
        // The visible code remains selectable when clipboard access is unavailable.
      }
      copy.textContent = 'Copié ✓';
      copy.classList.add('done');
      window.setTimeout(() => {
        copy.textContent = 'Copier';
        copy.classList.remove('done');
      }, 1600);
    });

    const countdown = root.querySelector('#offerCd');
    if (countdown) {
      const pad = (value) => String(value).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const remaining = Math.max(0, end - now);
        const hours = Math.floor(remaining / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        countdown.innerHTML = `Fin dans <b>${pad(hours)}:${pad(minutes)}:${pad(seconds)}</b>`;
      };
      tick();
      window.setInterval(tick, 1000);
    }

    const scarcity = root.querySelector('.scar');
    if (scarcity) {
      const left = Number(scarcity.dataset.scarcityLeft || 0);
      const total = Number(scarcity.dataset.scarcityTotal || 0);
      const fill = scarcity.querySelector('.fill');
      if (fill) fill.style.width = `${total > 0 ? Math.max(0, Math.min(100, left / total * 100)) : 0}%`;
    }

    let stickyTicking = false;
    const syncSticky = () => {
      stickyTicking = false;
      if (!sticky || !addButton) return;
      const atcRect = addButton.getBoundingClientRect();
      const show = window.innerWidth <= 760 || (window.scrollY > 120 && atcRect.top < 12);
      sticky.classList.toggle('show', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    const scheduleStickySync = () => {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(syncSticky);
    };
    if (sticky && addButton) {
      syncSticky();
      window.addEventListener('scroll', scheduleStickySync, { passive: true });
      window.addEventListener('resize', scheduleStickySync);
    }
    const requestJson = (url, options) => {
      const config = options || {};
      config.headers = Object.assign({
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }, config.headers || {});

      if (typeof fetch === 'function') {
        return fetch(url, config).then((response) => {
          if (!response.ok) {
            return response.json().catch(() => ({})).then((body) => {
              throw new Error(body.description || body.message || 'Erreur panier');
            });
          }
          return response.json();
        });
      }

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(config.method || 'GET', url);
        Object.keys(config.headers).forEach((key) => xhr.setRequestHeader(key, config.headers[key]));
        xhr.onload = () => {
          let body = {};
          try {
            body = xhr.responseText ? JSON.parse(xhr.responseText) : {};
          } catch (_) {
            body = {};
          }
          if (xhr.status < 200 || xhr.status >= 300) {
            reject(new Error(body.description || body.message || 'Erreur panier'));
            return;
          }
          resolve(body);
        };
        xhr.onerror = () => reject(new Error('Erreur panier'));
        xhr.send(config.body || null);
      });
    };
    const addWithAjax = (variantId, quantity) => requestJson('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
    }).then((body) => {
      document.dispatchEvent(new CustomEvent('ky:cart:open'));
      document.dispatchEvent(new CustomEvent('ky:cart:refresh'));
      return body;
    });

    addButton?.addEventListener('click', (event) => {
      event.preventDefault();
      if (addButton.disabled || addButton.dataset.available !== 'true') return;
      const variantId = Number(addButton.dataset.variantId || 0);
      if (!variantId) return;
      const selectedTier = root.querySelector('#tiers .tier.on');
      const quantity = Math.max(1, Number(selectedTier?.dataset.tier || 1));
      const lineTotal = Number(selectedTier?.dataset.price || addButton.dataset.variantPrice || 0);

      addButton.disabled = true;
      if (stickyAddButton) stickyAddButton.disabled = true;
      root.setAttribute('aria-busy', 'true');
      Promise.resolve(
        typeof fetch === 'function' && window.KYCart && typeof window.KYCart.add === 'function'
          ? window.KYCart.add(variantId, quantity, {}, lineTotal)
          : addWithAjax(variantId, quantity)
      ).catch((error) => {
        console.error(error);
      }).finally(() => {
        addButton.disabled = false;
        if (stickyAddButton) stickyAddButton.disabled = false;
        root.removeAttribute('aria-busy');
      });
    });
    stickyAddButton?.addEventListener('click', (event) => {
      event.preventDefault();
      if (stickyAddButton.disabled) return;
      addButton?.click();
    });

    const featuredReview = root.querySelector('#freview');
    const reviewDots = [...root.querySelectorAll('#frDots i')];
    const showReview = (index) => {
      reviewDots.forEach((dot, i) => dot.classList.toggle('on', i === index));
      const dot = reviewDots[index];
      if (!dot) return;
      const avatar = root.querySelector('#frAv');
      const quote = root.querySelector('#frQ');
      const name = root.querySelector('#frNm');
      if (avatar) avatar.textContent = dot.dataset.avatar || '•';
      if (quote) quote.textContent = `« ${dot.dataset.quote || ''} »`;
      if (name) name.textContent = dot.dataset.name || '';
    };
    reviewDots.forEach((dot, index) => dot.addEventListener('click', () => showReview(index)));
    if (featuredReview && reviewDots.length) featuredReview.style.display = '';

    const notifyForm = root.querySelector('#notifyForm');
    notifyForm?.addEventListener('submit', () => {
      root.querySelector('#notify')?.classList.add('sent');
    });

  });
})();
